import React, { useState } from 'react'

import { Box, Button } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { reverse } from 'named-urls'

import { ConfirmationDialog, MenuButton } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'
import { routes } from 'GuestRoutes'

// Ações da linha na listagem do portal: as permissões vêm do status do projeto,
// já que o convidado não tem as tags de permissão do app.
const ActionButtons = ({ privacyByDesign, refresh }) => {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [selectedAction, setSelectedAction] = useState(null)

  const history = useHistory()
  const snackbar = useSnackbar()
  const { organizationSlug } = useParams()

  const {
    AWAITING_REVIEW_STATUS_LABEL,
    CONFIRMATION_CHANGE_STATUS_TEXTS,
    SOFT_DELETE_STATUS_LABEL,
  } = constants.privacyByDesign

  const redirectTo = (route) =>
    history.push(
      reverse(route, {
        organizationSlug,
        privacyByDesignId: privacyByDesign?.id,
      }),
    )

  const handleDelete = async () => {
    try {
      await service.guestPortal.privacyByDesign.destroy({
        privacyByDesignId: privacyByDesign?.id,
      })

      snackbar.open({
        message: 'Projeto excluído com sucesso.',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao excluir o projeto.',
        variant: 'error',
      })
    } finally {
      setOpenConfirmationDialog(false)
    }
  }

  // A obrigatoriedade das respostas é validada pelo backend no change_status,
  // que devolve as questões pendentes na mensagem de erro.
  const handleSendToReview = async () => {
    try {
      await service.guestPortal.privacyByDesign.changeStatus({
        privacyByDesignId: privacyByDesign?.id,
        status: AWAITING_REVIEW_STATUS_LABEL,
      })

      snackbar.open({
        message: 'Projeto enviado para revisão!',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao enviar para revisão.',
        variant: 'error',
      })
    } finally {
      setOpenConfirmationDialog(false)
    }
  }

  const handleConfirm = () =>
    selectedAction === AWAITING_REVIEW_STATUS_LABEL
      ? handleSendToReview()
      : handleDelete()

  const openConfirmation = (action) => {
    setSelectedAction(action)
    setOpenConfirmationDialog(true)
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <MenuButton>
          <Button
            color="secondary"
            fullWidth
            onClick={() => redirectTo(routes.privacyByDesign.show)}
          >
            Visualizar
          </Button>
          {helpers.privacyByDesign.canEdit(privacyByDesign?.status) && (
            <Button
              color="secondary"
              fullWidth
              onClick={() => redirectTo(routes.privacyByDesign.edit)}
            >
              Editar
            </Button>
          )}
          {helpers.privacyByDesign.canSendToReview(privacyByDesign?.status) && (
            <Button
              color="secondary"
              fullWidth
              onClick={() => openConfirmation(AWAITING_REVIEW_STATUS_LABEL)}
            >
              Enviar para Revisão
            </Button>
          )}
          {helpers.privacyByDesign.canDelete(privacyByDesign?.status) && (
            <Button
              color="secondary"
              fullWidth
              onClick={() => openConfirmation(SOFT_DELETE_STATUS_LABEL)}
            >
              Excluir
            </Button>
          )}
        </MenuButton>
      </Box>
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        actionAcceptButton={handleConfirm}
        text={CONFIRMATION_CHANGE_STATUS_TEXTS?.[selectedAction]}
        textButton="Confirmar"
      />
    </>
  )
}

export default ActionButtons
